import angular from 'angular'
import utils from 'utils'
class accountModalCtrl {
    constructor(
        $scope,
        $uibModalInstance,
        modalData,
        httpRequest,
        $uibModal,
        logger,
    ) {
        $scope.currentUserInfo = JSON.parse(localStorage.user_info).user
        $scope.modalData = modalData
        $scope.newDictData = angular.copy(modalData.dictData)
        $scope.orgList = setSelect(modalData.orgList) 
        $scope.selectedRows = modalData.selectedRows
        const { type } = $scope.modalData
        const filterConditions = {
            'query': (el) => !['04', '05'].includes(el.enumCode),
            'save': (el) => ['02', '03'].includes(el.enumCode),
            'adjust': (el) => ['02', '03', '06'].includes(el.enumCode),
        };

        $scope.newDictData['entry_purpose_status'] = $scope.newDictData['entry_purpose_status'].filter(filterConditions[type]);
        $scope.selectedOrgList = [
            {
              orgId: $scope.currentUserInfo.currentOrgId,
              orgName: $scope.currentUserInfo.currentOrgName,
              checked: true,
            },
          ]
        $scope.queryParam = {
            entryPurposeStatus: '01',
            invoiceDateStart: '',
            invoiceDateEnd: '',
            orgId: $scope.currentUserInfo.currentOrgId,
        }
        $scope.saveParam = {
            companyEntryStatus: '02',
            entryDate: type === 'query' ? '' : $scope.selectedRows[0].entryDate
        }
        //机构树的check配置信息
        $scope.config = {
            check: {
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
                chkStyle: 'radio',
                radioType: 'all',
            },
        }
        $scope.title = type === 'query' ? '入账查询' : type === 'save' ? '入账保存' : '入账调整'
        // 所选择的机构名称
        $scope.handleOrgChange = function (orgData) {
            $scope.queryParam.orgId = orgData[0].orgId
        }
        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function ok() {
            if (!dataCheck()) return
            let api = type === 'query' ? 'post_queryInvoiceEntry' : type === 'save' ? 'post_saveInvoiceEntry' : 'post_adjustInvoiceEntry'
            httpRequest[api](type === 'query' ? $scope.queryParam : saveAndAdjustdata(),`${$scope.title}成功`).then((res) => {
                $uibModalInstance.close()
            })

        }
        function setSelect(list) {
            return list.map(el => ({
                orgId:el.orgId,
                orgName:el.orgName,
                checked: $scope.currentUserInfo.currentOrgId == el.orgId
            }));
        }
        function dataCheck() {
            const { invoiceDateStart, invoiceDateEnd } = $scope.queryParam
            if (type === 'query' && (!invoiceDateStart || !invoiceDateEnd)) {
                logger.logError('发票起止日期不能为空')
                return false
            }
            if (type === 'query' && utils.DateMinus(invoiceDateStart, invoiceDateEnd) > 31) {
                logger.logError('起始日期控制小于等于31天')
                return false
            }
            if (type === 'adjust' && hasSamePropertyValues()) {
                logger.logError('数据存在调整入账用途与税局入账用途存在相同，请检查。')
                return false
            }
            return true
        }
        function saveAndAdjustdata() {
            $scope.selectedRows.forEach(el => {
                el = Object.assign(el, $scope.saveParam)
            });
            return $scope.selectedRows
        }
        function hasSamePropertyValues() {
            const { companyEntryStatus } = $scope.saveParam
            return $scope.selectedRows.some(el => el.companyEntryStatus == companyEntryStatus);
        }
    }
}

accountModalCtrl.$inject = [
    '$scope',
    '$uibModalInstance',
    'modalData',
    'httpRequest',
    '$uibModal',
    'logger'
]
export default accountModalCtrl



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/InvAccountManagement/accountModalCtrl.js